module.exports = __webpack_public_path__ + "static/img/banner-2.03715bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-2.png
// module id = AEfp
// module chunks = 1